
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomatherancabs() {



    const cardData =
    {
        keyword: 'Pune to Matheran Cabs',
        heading: 'Platinum24 Cabs: Pune to Matheran Cabs',
        headingDescription: ' Platinum24 Cabs provides reliable Pune to Matheran Cabs, perfect for families, couples, and groups planning a weekend getaway to the eco-friendly hill station. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a safe and comfortable journey up to the Dasturi Naka entry point, as vehicles are restricted inside Matheran. With professional chauffeurs, timely pickups, and transparent fares, we make your trip stress-free and convenient. Whether you’re planning sightseeing at Panorama Point, Charlotte Lake, or just a peaceful retreat, Platinum24 Cabs guarantees affordable, punctual, and enjoyable travel from Pune to Matheran.',

        top: 'Top Places to Visit in Matheran with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Panorama Point",
    "description": "Panorama Point in Matheran lives up to its name, offering 360-degree views of the Sahyadri ranges and valleys. It is the best spot for sunrise and sunset photography. The trek to the point is peaceful, surrounded by dense forests. Clouds and mist in monsoon make the scenery magical. Horse rides are also available for visitors. Panorama Point is Matheran’s top viewpoint of natural beauty."
  },
  {
    "title": "Echo Point",
    "description": "Echo Point is one of the most popular attractions in Matheran, famous for its natural echo effect. Visitors shout and hear their voices bounce back across the hills. The spot also offers sweeping valley views and a cool breeze. It is a favorite among families and kids. Street vendors sell snacks and drinks nearby. Echo Point is Matheran’s fun-filled natural wonder."
  },
  {
    "title": "Charlotte Lake",
    "description": "Charlotte Lake is a serene water reservoir that supplies drinking water to Matheran. Surrounded by lush greenery, it is a peaceful picnic spot. Monsoon enhances its beauty with waterfalls feeding the lake. Birdwatchers spot migratory species here. The lake also has temples nearby adding a spiritual touch. Charlotte Lake is Matheran’s tranquil nature retreat."
  },
  {
    "title": "Louisa Point",
    "description": "Louisa Point offers dramatic views of Prabal Fort, Vishalgad Fort, and surrounding valleys. It is a favorite for photographers due to its clear views and sunsets. During monsoon, waterfalls cascade across the cliffs, creating scenic beauty. Couples and families enjoy the peaceful environment here. The trek to Louisa Point is moderately easy. It is Matheran’s iconic viewpoint for history and nature lovers."
  },
  {
    "title": "One Tree Hill Point",
    "description": "One Tree Hill Point is a unique viewpoint where a lone tree stands on a hilltop, surrounded by valleys. The spot is popular among trekkers and nature photographers. The trail here is adventurous and offers panoramic views. Legends connect it with British-era stories of discovery. Monsoon makes it misty and magical. One Tree Hill is Matheran’s quirky natural landmark."
  },
  {
    "title": "Monkey Point",
    "description": "Monkey Point is a lively spot in Matheran where groups of monkeys roam freely. It offers valley views along with entertainment from the playful monkeys. Visitors are advised to be cautious with food items. The point is a favorite stop for children. Its natural setting adds to the charm. Monkey Point is Matheran’s fun stop filled with wildlife energy."
  },
  {
    "title": "Shivaji’s Ladder",
    "description": "Shivaji’s Ladder is a series of stone steps that descend into the valley, believed to have been used by Chhatrapati Shivaji Maharaj for training. The steps lead to picturesque forest trails. Trekkers and adventure seekers love exploring this route. The view from the top is breathtaking. It connects history with adventure. Shivaji’s Ladder is Matheran’s blend of Maratha history and trekking."
  },
  {
    "title": "Porcupine Point (Sunset Point)",
    "description": "Porcupine Point, also known as Sunset Point, is famous for its breathtaking evening views. The sun setting behind the hills creates golden hues across the valley. The point also overlooks Prabal Fort. Vendors sell local snacks, enhancing the experience. Couples and photographers love this spot. Porcupine Point is Matheran’s romantic sunset retreat."
  },
  {
    "title": "Pisarnath Temple",
    "description": "Pisarnath Temple is one of the oldest shrines in Matheran, dedicated to Lord Shiva. Located near Charlotte Lake, it attracts both pilgrims and tourists. The temple is simple yet powerful in its spiritual aura. During Mahashivratri, it becomes a hub of devotion. Surrounded by greenery, it is also scenic. Pisarnath Temple is Matheran’s divine spiritual corner."
  },
  {
    "title": "Toy Train Ride (Matheran Hill Railway)",
    "description": "The Matheran Hill Railway is a UNESCO-recognized narrow-gauge toy train that runs from Neral to Matheran. The 21 km journey passes through tunnels, forests, and mountain curves. It offers breathtaking views of the Sahyadris. Families and tourists enjoy the nostalgic ride. The train is especially scenic during monsoon. The toy train is Matheran’s heritage ride of charm and adventure."
  }
],



  "services": [
    {
      "name": "Pune to Matheran Taxi Service",
      "description": "Experience a comfortable and hassle-free journey with our Pune to Matheran Taxi Service. Whether you are traveling solo, with family, or a group, our well-maintained taxis provide a safe and scenic ride through the beautiful routes connecting Pune and Matheran. Enjoy door-to-door service with professional drivers who know the best routes to ensure timely arrival and a smooth trip. Perfect for weekend getaways, nature lovers, and pilgrims visiting the serene hill station of Matheran, our taxi service is reliable, affordable, and tailored to meet all your travel needs."
    },
    {
      "name": "Matheran Cab from Pune",
      "description": "Our Matheran Cab from Pune offers you a premium travel experience with clean, comfortable vehicles and experienced drivers. Avoid the stress of public transport and long waits by opting for a private cab that gives you the freedom to explore at your own pace. Whether it’s a leisure trip, family outing, or business travel, we provide customizable packages that fit your budget and preferences. Enjoy seamless booking, 24/7 availability, and excellent customer support throughout your journey to the charming hill station of Matheran."
    },
    {
      "name": "Pune Matheran Taxi Booking",
      "description": "Book your Pune to Matheran taxi quickly and easily with our online and phone booking options. We prioritize your convenience by offering instant confirmation, flexible cancellation policies, and transparent pricing without hidden costs. Our Pune Matheran Taxi Booking service is designed to provide you with peace of mind, allowing you to plan your trip effortlessly. With a wide range of vehicle options from compact sedans to spacious SUVs, we cater to all group sizes and travel requirements."
    },
    {
      "name": "Taxi Service Pune to Matheran",
      "description": "Our Taxi Service from Pune to Matheran is dedicated to delivering a premium travel experience with utmost comfort and safety. The route from Pune to Matheran is scenic yet winding, so our trained drivers are adept at navigating the terrain with care. Whether you are heading to Matheran for a weekend retreat, sightseeing, or spiritual visit, our taxi service ensures timely pickups and drop-offs, allowing you to maximize your time at the destination. Enjoy competitive rates, clean cars, and professional drivers committed to making your journey memorable."
    },
    {
      "name": "Matheran Cab Rental Pune",
      "description": "Rent a cab from Pune to Matheran with us for a stress-free and enjoyable travel experience. Our Matheran Cab Rental Pune service offers flexible rental durations, allowing you to customize your trip itinerary. Whether you need a cab for a day trip, overnight stay, or multiple days, we have packages designed to suit your needs. Our fleet includes air-conditioned vehicles equipped with all modern amenities to keep you comfortable throughout the journey. Booking with us means getting the best value for your money with no compromise on quality or service."
    },
    {
      "name": "Pune to Matheran Taxi Fare",
      "description": "We offer transparent and affordable taxi fares from Pune to Matheran with no hidden charges. Our pricing is competitive and based on distance, type of vehicle, and rental duration. Whether you choose a budget-friendly sedan or a luxury SUV, you’ll find our taxi fares reasonable and well worth the convenience, comfort, and personalized service you receive. Detailed fare estimates are provided upfront during booking, so you can plan your travel expenses easily without surprises."
    },
    {
      "name": "Pune Matheran Private Taxi",
      "description": "Travel in privacy and comfort with our Pune Matheran Private Taxi option. Ideal for families, couples, or small groups seeking exclusive travel arrangements, our private taxis provide personalized attention and flexible scheduling. Enjoy the freedom to stop at scenic spots along the way or take detours as per your preference. Our private taxi service ensures a stress-free and intimate travel experience with courteous drivers dedicated to your safety and satisfaction."
    },
    {
      "name": "Matheran Cab Packages Pune",
      "description": "Explore our specially designed Matheran Cab Packages from Pune that cater to various travel needs, including weekend trips, pilgrimage tours, and leisure excursions. These packages often include round-trip transport, driver allowances, tolls, and parking fees, providing an all-inclusive solution for your journey. Benefit from discounts on longer rentals and group bookings. Our flexible packages allow you to customize your trip itinerary, making it easier than ever to plan a memorable visit to Matheran."
    },
    {
      "name": "Pune to Matheran One Way Cab",
      "description": "Book a convenient one-way cab from Pune to Matheran with us for seamless point-to-point travel. Perfect for travelers who prefer different arrangements for return trips or onward journeys, our one-way taxi service ensures timely pickup and safe drop-off without any unnecessary waiting or detours. Enjoy the flexibility of choosing your vehicle type and travel schedule, all backed by professional drivers and customer support."
    },
    {
      "name": "Matheran Taxi Charges Pune",
      "description": "Our Matheran Taxi Charges from Pune are designed to offer you excellent value for money. Charges are calculated based on distance, vehicle type, and duration of hire, with clear terms and no hidden costs. We provide detailed quotations before you confirm your booking, ensuring full transparency. Whether you’re planning a short day trip or an extended visit to Matheran, our pricing is competitive and fair, reflecting the high standard of service you can expect."
    },
    {
      "name": "Pune to Matheran Taxi Hire",
      "description": "Hire a taxi from Pune to Matheran easily with our reliable and customer-friendly taxi hire service. We offer a wide selection of vehicles including hatchbacks, sedans, SUVs, and tempo travellers to suit different group sizes and budgets. Our taxi hire service is perfect for travelers seeking convenience, comfort, and a hassle-free booking experience. Enjoy personalized assistance from our team to select the best vehicle and package for your trip."
    },
    {
      "name": "Matheran Cab for Weekend Trips Pune",
      "description": "Planning a weekend getaway to Matheran from Pune? Our dedicated cab service specializes in weekend trips, providing round-trip options with flexible timings and competitive rates. Relax and enjoy the beautiful hill station without worrying about transport logistics. Our drivers are knowledgeable about the local area and can suggest popular attractions and dining spots, making your weekend trip both comfortable and memorable."
    },
    {
      "name": "Pune to Matheran Outstation Taxi",
      "description": "For those seeking reliable outstation taxi services, our Pune to Matheran Outstation Taxi offers long-distance travel with complete comfort and safety. We cover not only point-to-point transfers but also multi-day rentals, allowing you to explore Matheran and nearby locations without any travel worries. Our outstation taxis are equipped with all necessary amenities, and our drivers are experienced in handling long journeys with professionalism and care."
    },
    {
      "name": "Matheran Taxi with Driver Pune",
      "description": "Our Matheran Taxi with Driver service from Pune ensures a stress-free journey with courteous, knowledgeable, and licensed drivers. They assist you throughout your trip, including help with luggage and local navigation, making your travel experience smooth and enjoyable. Drivers are well-versed with Matheran’s routes and points of interest, ensuring safe driving on the hill station’s winding roads."
    },
    {
      "name": "Taxi Service Pune to Matheran",
      "description": "Rely on our professional Taxi Service from Pune to Matheran for an easy and pleasant travel experience. We focus on punctuality, safety, and customer satisfaction. Our modern fleet of vehicles is regularly maintained to guarantee comfort and reliability. Whether you need a taxi for a single trip, round trip, or extended rental, we provide tailored solutions to meet your requirements with excellent service standards."
    }
  ],
  "tableData": [
    ["Pune to Matheran Taxi Service", "Matheran Cab from Pune"],
    ["Pune Matheran Taxi Booking", "Taxi Service Pune to Matheran"],
    ["Matheran Cab Rental Pune", "Pune to Matheran Taxi Fare"],
    ["Pune Matheran Private Taxi", "Matheran Cab Packages Pune"],
    ["Pune to Matheran One Way Cab", "Matheran Taxi Charges Pune"],
    ["Pune to Matheran Taxi Hire", "Matheran Cab for Weekend Trips Pune"],
    ["Pune to Matheran Outstation Taxi", "Matheran Taxi with Driver Pune"],
    ["Taxi Service Pune to Matheran", "—"]
  ],


      "whychoose": [
    {
      "WhyChooseheading": "Comfortable Pune to Matheran Cab Service",
      "WhyChoosedescription": "Platinum24 Cabs provides safe and comfortable cab rides from Pune to the serene hill station of Matheran."
    },
    {
      "WhyChooseheading": "Experienced Drivers Familiar with Pune-Matheran Routes",
      "WhyChoosedescription": "Our skilled drivers know the best routes and ensure a smooth, timely journey to Matheran."
    },
    {
      "WhyChooseheading": "Well-Maintained and Spacious Vehicles",
      "WhyChoosedescription": "Travel in clean, air-conditioned cabs with ample space for passengers and luggage."
    },
    {
      "WhyChooseheading": "Flexible One-Way and Round Trip Options",
      "WhyChoosedescription": "Choose booking options that suit your travel plans from Pune to Matheran and back."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Enjoy upfront pricing inclusive of fuel, tolls, and driver allowances for hassle-free travel."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Booking Assistance",
      "WhyChoosedescription": "Our dedicated support team is available round the clock to help with bookings and inquiries."
    },
    {
      "WhyChooseheading": "Ideal for Family Trips, Friends, and Solo Travelers",
      "WhyChoosedescription": "Our Pune to Matheran cab services cater to all types of travelers."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options for Your Comfort",
      "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, or tempo travellers based on your group size and preferences."
    }
  ]




































    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs provide cab services from Pune to Matheran?',
        answer: 'Yes, Platinum24 Cabs offers reliable and comfortable cab services for travel between Pune and Matheran.',
    },
    {
        question: 'How can I book a Pune to Matheran cab with Platinum24 Cabs?',
        answer: 'You can easily book your Pune to Matheran cab through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Matheran trips?',
        answer: 'We offer a variety of vehicles including sedans, SUVs, and tempo travellers to suit your travel preferences and group size.',
    },
    {
        question: 'Are the drivers experienced for Pune to Matheran routes?',
        answer: 'Yes, all our drivers are professional, experienced, and knowledgeable about the Pune to Matheran route.',
    },
    {
        question: 'Can I book a round trip cab from Pune to Matheran?',
        answer: 'Absolutely! We provide round-trip cab services with flexible scheduling to accommodate your travel plans.',
    },
    {
        question: 'What is included in the fare for Pune to Matheran cab services?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for extra stops or waiting time.',
    },
    {
        question: 'Can I customize pickup and drop-off locations for Pune to Matheran rides?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points along the Pune-Matheran route.',
    },
    {
        question: 'Are safety measures followed during Pune to Matheran cab rides?',
        answer: 'All vehicles are regularly sanitized, and our drivers follow strict safety protocols for your protection.',
    },
    {
        question: 'Is it possible to hire a cab for multiple days for Pune to Matheran travel?',
        answer: 'Yes, we offer hourly and multi-day rental packages tailored to your travel needs.',
    },
    {
        question: 'Does Platinum24 Cabs provide corporate taxi services from Pune to Matheran?',
        answer: 'Yes, we offer customized corporate travel solutions including priority support and flexible billing for Pune to Matheran routes.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rahul Kulkarni',
        feedback: 'The Pune to Matheran cab service by Platinum24 Cabs was fantastic. The driver was punctual and the vehicle was very comfortable.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Ananya Deshpande',
        feedback: 'Great experience traveling to Matheran from Pune. Easy booking and excellent service by Platinum24 Cabs.',
        rating: 5,
    },
];



















































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];







const puneMatheranSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Reliable and affordable Pune to Matheran Cab Service offering private taxis, one-way trips, weekend getaway cabs, and outstation taxi rentals with driver.",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Pune to Matheran Cab Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Pune to Matheran Taxi Service"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Matheran Cab Rental Pune"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Pune to Matheran One Way Cab"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Matheran Cab for Weekend Trips"
        }
      }
    ]
  },
  "telephone": "+91-XXXXXXXXXX",
  "serviceType": [
    "Pune to Matheran Taxi Service",
    "Matheran Cab from Pune",
    "Pune Matheran Taxi Booking",
    "Taxi Service Pune to Matheran",
    "Matheran Cab Rental Pune",
    "Pune to Matheran Taxi Fare",
    "Pune Matheran Private Taxi",
    "Matheran Cab Packages Pune",
    "Pune to Matheran One Way Cab",
    "Matheran Taxi Charges Pune",
    "Pune to Matheran Taxi Hire",
    "Matheran Cab for Weekend Trips Pune",
    "Pune to Matheran Outstation Taxi",
    "Matheran Taxi with Driver Pune",
    "Taxi Service Pune to Matheran"
  ]
};







    return (
        <div>
<Helmet>
  <title>Pune to Matheran Cab Service | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Reliable and affordable Pune to Matheran Cab Service offering private taxis, one-way trips, weekend getaway cabs, and outstation taxi rentals with driver."
  />
  <meta
    name="keywords"
    content="Pune to Matheran Taxi Service, Matheran Cab from Pune, Pune Matheran Taxi Booking, Taxi Service Pune to Matheran, Matheran Cab Rental Pune, Pune to Matheran Taxi Fare, Pune Matheran Private Taxi, Matheran Cab Packages Pune, Pune to Matheran One Way Cab, Matheran Taxi Charges Pune, Pune to Matheran Taxi Hire, Matheran Cab for Weekend Trips Pune, Pune to Matheran Outstation Taxi, Matheran Taxi with Driver Pune, Taxi Service Pune to Matheran"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneMatheranSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/51.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomatherancabs;